import { render, staticRenderFns } from "./Resetpassword.vue?vue&type=template&id=b2c57e88&scoped=true&"
import script from "./Resetpassword.vue?vue&type=script&lang=js&"
export * from "./Resetpassword.vue?vue&type=script&lang=js&"
import style0 from "./Resetpassword.vue?vue&type=style&index=0&id=b2c57e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c57e88",
  null
  
)

export default component.exports